import { IndicatorType } from "@/models/enum/indicatorType";
import { RiskCategory } from "@/models/enum/riskCategory";

export function getIndicatorTypesForRiskCategory(
  riskCategory: RiskCategory
): IndicatorType[] {
  switch (riskCategory) {
    case RiskCategory.BusinessIntegrity:
      return [
        IndicatorType.DisclosedBreaches,
        IndicatorType.LackingComplianceProcedures,
        IndicatorType.LackingDedicatedPersonnel,
        IndicatorType.InternalInvestigations,
        IndicatorType.FinancialSupervision,
        IndicatorType.PEPCRA,
        IndicatorType.DataOutsideEuEea,
        IndicatorType.SubProcessedData,
        IndicatorType.Sanctions,
      ];

    case RiskCategory.LabourAndHumanRight:
      return [
        IndicatorType.DisclosedBreaches,
        IndicatorType.LackingComplianceProcedures,
        IndicatorType.LackingDedicatedPersonnel,
        IndicatorType.ConflictMinerals,
      ];

    case RiskCategory.HealthAndSafety:
      return [
        IndicatorType.DisclosedBreaches,
        IndicatorType.LackingComplianceProcedures,
        IndicatorType.LackingDedicatedPersonnel,
      ];

    case RiskCategory.Environment:
      return [
        IndicatorType.DisclosedBreaches,
        IndicatorType.LackingComplianceProcedures,
        IndicatorType.LackingDedicatedPersonnel,
        IndicatorType.LackingEnvironmentalMeasures,
      ];
    case RiskCategory.SupplierManagement:
      return [IndicatorType.LackingComplianceProcedures];
  }
}
